/**
 * Explore's ground game: none. Nothing is filed with the server, no build or
 * forge row is drawn, no building stands on the plot and the Crafting tab has
 * no link to ask through. The handles answer as ground nobody holds, so the
 * inspector draws no parcel or claim card over it.
 */

import type { AtlasGroundGame } from './groundGame';

export const EXPLORE_GROUND: AtlasGroundGame = {
  id: 'explore',
  buildRowsMarkup: () => '',
  createSiteGround: () => ({
    cellBySub: new Map(),
    addrOfSub: () => null,
    cellOfSub: () => null,
    parentOf: () => null,
    resolveAddresses: () => Promise.resolve(),
    surveyHere: () => {},
    refreshClaimOverlay: () => {},
    stakeSelected: () => Promise.resolve(),
    bootGround: () => Promise.resolve(),
    refreshStructures: () => {},
  }),
  createBuildPanel: ({ overlay }) => ({
    syncBuildButton: () => {},
    showForgeToast: () => {},
    // The rover's skin row and the imagery credit are not the ground game's;
    // they ride on this handle because the rover and the pyramid read them here.
    skinRow: overlay.querySelector('#pc-skin-row') as HTMLElement,
    creditEl: overlay.querySelector('#pc-credit') as HTMLElement,
    pyramidCreditEl: overlay.querySelector('#atlas-pyramid-credit') as HTMLElement,
  }),
  createStructureView: () => ({
    update: () => {},
    probe: {
      structureDebug: () => ({ stats: null, label: null, entries: [] }),
      structureCells: () => [],
      refreshStructures: () => {},
      haulDebug: () => [],
    },
  }),
  createGroundLink: () => ({ dispose: () => {} }),
  cellBuildings: () => [],
  openBuilding: () => {},
};
